const PAYMENT_METHOD_BY_NUM = {
  LEASE: 1,
  LUMP_SUM: 2,
  RENTAL_MONTHLY: 3,
  RENTAL_YEARLY: 4,
  RENTAL_TWO_YEARLY: 5,
  RENTAL_THREE_YEARLY: 6
}

const PAYMENT_METHOD_BY_STR = {
  LEASE: '7개월 분할 결제',
  LUMP_SUM: '일시불 구매',
  RENTAL_MONTHLY: '매월 플랜',
  RENTAL_YEARLY: '1년 플랜',
  RENTAL_TWO_YEARLY: '2년 플랜',
  RENTAL_THREE_YEARLY: '3년 플랜'
}

const PAYMENT_METHOD_BY_STR_IN_ENGLISH = {
  LEASE: 'lease',
  LUMP_SUM: 'lump_sum',
  RENTAL: 'rental'
}

function convertPaymentMethodInStrBy (num) {
  switch (num) {
    case PAYMENT_METHOD_BY_NUM.LEASE:
      return PAYMENT_METHOD_BY_STR_IN_ENGLISH.LEASE
    case PAYMENT_METHOD_BY_NUM.LUMP_SUM:
      return PAYMENT_METHOD_BY_STR_IN_ENGLISH.LUMP_SUM
  }
}

function convertPaymentMethodInKorBy (num) {
  switch (num) {
    case PAYMENT_METHOD_BY_NUM.LEASE:
      return PAYMENT_METHOD_BY_STR.LEASE
    case PAYMENT_METHOD_BY_NUM.LUMP_SUM:
      return PAYMENT_METHOD_BY_STR.LUMP_SUM
  }
}
export { PAYMENT_METHOD_BY_NUM, PAYMENT_METHOD_BY_STR, PAYMENT_METHOD_BY_STR_IN_ENGLISH, convertPaymentMethodInStrBy, convertPaymentMethodInKorBy }



// WEBPACK FOOTER //
// ./src/modules/payment_methods.js